import { Controller } from "@hotwired/stimulus"
import { useTransition } from 'stimulus-use'

export default class extends Controller {
  static targets = ['list']

  connect () {
    useTransition(this, {
      element: this.listTarget
    })
  }

  toggle() {
    this.toggleTransition()
  }

  hide(event) {
    if (event.type === 'resize') {
      if (!this.listTarget.classList.contains('hidden')) {
        this.leave()
      }
    } else if (!this.element.contains(event.target) && !this.listTarget.classList.contains('hidden')) {
      this.leave()
    }
  }
}
